import { Chart } from "react-google-charts";
import { useMutation } from "react-query";
import {
  getFormattedDateForDashboard,
  getOneMonthAgoDate,
} from "global/helpers";
import DateGrid from "components/DateFilter/DateGrid";
import { useEffect, useState } from "react";
import { getPayments } from "./DashboardServices";

const Payments = () => {
  const [startDate, setStartDate] = useState<Date>(getOneMonthAgoDate());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [dateCategory, setDateCategory] = useState(null);

  const [payments, setPayments] = useState<any>([
    [{ date: getFormattedDateForDashboard(), paymentIn: 0.0, paymentOut: 0.0 }],
  ]);

  const mutate = useMutation(getPayments, {
    onSuccess(data) {
      setPayments(data);
    },
  });

  useEffect(() => {
    if (startDate || endDate) {
      mutate.mutate({ startDate: startDate, endDate: endDate });
    }
  }, [startDate, endDate]);

  let data = [["Year", "Payment In", "Payment Out"]];

  payments?.forEach((e) => {
    data.push([e.date, e.paymentIn, e.paymentOut]);
  });
  const options = {
    chart: {
      title: "Payments",
    },
  };

  return (
    <div className="row w-100">
      <DateGrid
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        dateCategory={dateCategory}
        setDateCategory={setDateCategory}
        isFullWidth={true}
        isForExpenses={true}
      />

      {data.length > 1 ? (
        <Chart
          chartType="Bar"
          width="700px"
          height="350px"
          loader={<div>Loading Chart</div>}
          data={data}
          options={options}
        />
      ) : null}
    </div>
  );
};

export default Payments;
